<template>
  <form v-if="delivery.createdBy">
    <TheInput
      :dark="true"
      type="datepicker"
      :locked="true"
      label="ДАТА НА ЗАЯВКАТА (АВТОМ.)"
      :value="delivery.createdAt"
    />
    <TheInput
      :dark="true"
      prop="name"
      :locked="true"
      label="ЗАЯВКА ОТ СЛУЖИТЕЛ (АВТОМ.)"
      :value="delivery.createdBy.name"
    />
    <TheInput
      :dark="true"
      placeholder="Кратко описание"
      label="ЗАЯВКА ЗА"
      v-model="delivery.deliveryFor"
      @update:modelValue="delivery.deliveryFor = $event"
    />
    <TheInput
      :dark="true"
      type="datepicker"
      placeholder="Изберете дата"
      label="ЗАЯВКА ЗА ДАТА"
      :disabledDates="{ to: new Date() }"
      v-model="delivery.deliveryDate"
      @update:modelValue="delivery.deliveryDate = $event"
    />
    <TheInput
      :dark="true"
      type="dropdown"
      :options="urgencyTypes"
      prop="name"
      propValue="value"
      placeholder="Спешност"
      label="СПЕШНА ЗАЯВКА"
      :value="delivery.urgency"
      @update:modelValue="delivery.urgency = $event.value"
    />

    <TheInput
      :dark="true"
      :locked="true"
      label="ЗАЯВКА ЗА ОБЕКТ"
      placeholder="Изберете обект"
      :value="getDeliveryLocation(delivery)"
      @click="selectLocation = true"
    />

    <TheInput
      :dark="true"
      type="textarea"
      placeholder="Въведете свободен текст тук (от доставчик)"
      label="КОМЕНТАР ОТДЕЛ ДОСТАВКИ"
      :textareaRows="5"
      v-model="delivery.comment"
    />

    <TheModal
      v-if="selectLocation"
      :onlyCancel="true"
      @close="selectLocation = false"
    >
      <CompaniesTree
        :showActiveProjects="true"
        :justSelecting="true"
        @selected="selectCompanyProject($event)"
      />
    </TheModal>
  </form>
</template>

<script>
import TheInput from "@/components/TheInput.vue";
import TheModal from "@/components/shared/TheModal.vue";
import CompaniesTree from "@/components/shared/CompaniesTree.vue";
export default {
  props: ["delivery"],
  components: { TheInput, CompaniesTree, TheModal },
  data() {
    return {
      selectLocation: false,
      urgencyTypes: [
        { name: "Неспешна: не е спешна", value: "low" },
        { name: "Средно: доставка до края на деня", value: "mid" },
        { name: "Спешна: приоритетна заявка", value: "high" },
      ],
    };
  },
  methods: {
    getDeliveryLocation(d) {
      if (d.location) {
        return `${d.location.companyName} > ${d.location.projectName}`;
      }
    },
    selectCompanyProject(e) {
      this.delivery.location = e;
      this.selectLocation = false;
    },
  },
};
</script>
